import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Message } from 'src/app/classes/message';
import { SocketService } from './socket.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private socket?: SocketService;
  private resetSubject = new ReplaySubject<any>();

  constructor(private httpClient: HttpClient, private apiService: ApiService) { }

  public init() {
    this.socket = new SocketService(this.apiService)
  }
  
  public delivered(messageId: number): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/messages/${messageId}/delivered`, {});
  }

  public list(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/messages`);
  }

  public listShift(shiftId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/messages`, { params: new HttpParams({ fromObject: { shift_id: shiftId } }) });
  }

  public update(since: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/messages`, { params: new HttpParams({ fromObject: { since: since } }) });
  }

  public listen(): Observable<Message> {
    if (!this.socket) {
      console.warn('Socket accessed before initialization in MessageService.listen()');
      return new Observable();
    }
    return this.socket.fromEvent('message')
  }

  public listenReset() {
    return this.resetSubject.asObservable();
  }

  public reset(ignore: boolean) {
    this.resetSubject.next(ignore)
  }

  public unlisten() {
    return this.socket?.removeListener('message')
  }

  public unread(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/messages/unread`);
  }

  public message(message: string): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/messages`, { message: message });
  }

  public messageShift(shiftId: number, message: string): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/shifts/${shiftId}/messages`, { message: message });
  }

  public connect() {
    this.socket?.connect();
  }
  
  public disconnect() {
    this.socket?.disconnect();
  }
}
